import { render } from "./ManageCustomerBanks.vue?vue&type=template&id=65a3416e&scoped=true"
import script from "./ManageCustomerBanks.vue?vue&type=script&lang=js"
export * from "./ManageCustomerBanks.vue?vue&type=script&lang=js"

import exportComponent from "C:\\xampp\\htdocs\\Ltd24ore-client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65a3416e"]])

export default __exports__